// Collection detail route (index)

import { createFileRoute } from '@tanstack/react-router';

import { CollectionDetailPage } from '@/features/datahub/collections/CollectionDetailPage';

export const Route = createFileRoute('/_authenticated/datahub/collections/$collectionId/')({
  component: CollectionDetailPage,
});
